import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const TrashIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/trash"><path id="Icon" d="M14.7404 9L14.3942 18M9.60577 18L9.25962 9M4.77235 5.79057C5.91878 5.61744 7.07849 5.48485 8.25 5.39432C9.48744 5.2987 10.738 5.25 12 5.25C13.262 5.25 14.5126 5.2987 15.75 5.39432C16.9215 5.48485 18.0812 5.61744 19.2276 5.79057C19.5696 5.84222 19.9104 5.89747 20.25 5.95629M19.2276 5.79057L18.1598 19.6726C18.0696 20.8448 17.0921 21.75 15.9164 21.75H8.08357C6.90786 21.75 5.93037 20.8448 5.8402 19.6726L4.77235 5.79057M3.75 5.95629C4.08957 5.89747 4.43037 5.84222 4.77235 5.79057M15.75 5.39432V4.47819C15.75 3.29882 14.8393 2.31423 13.6606 2.27652C13.1092 2.25889 12.5556 2.25 12 2.25C11.4444 2.25 10.8908 2.25889 10.3394 2.27652C9.16065 2.31423 8.25 3.29882 8.25 4.47819V5.39432" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default TrashIcon;